import React, { useEffect, useRef, useState } from "react"
import { AdminIcons } from "../Shared/AdminIcon"
import { ScreenHeader } from "../UI/Elements"
import { useTranslationsManager } from "./useTranslationsManager";
import Select from 'react-select';
import { Overlay } from "../UI/Overlay";

export const TranslationsManager = () => {

    const ops = useTranslationsManager();

    useEffect(() => {
        ops.load();
    }, [, ops.plantTypeId]);



    const hide_no = ops.languages.indexOf("no") < 0;
    const hide_en = ops.languages.indexOf("en") < 0;
    const hide_enus = ops.languages.indexOf("en-us") < 0;



    return (
        <div className="translations-screen">
            <Overlay visible={ops.loading} />
            <ScreenHeader text="Översättningar" icon={AdminIcons.language} />

            {/****************************************** TOOLBOX *******************************************/}
            <div className="toolbox">
                <div>
                    <label>filtrera namn</label><br />
                    <input type="text" onChange={e => ops.filterName(e.target.value)} />
                </div>
                <div style={{ minWidth: "350px" }}>
                    <label>Typ</label>

                    <Select
                        value={(ops.plantTypes ?? []).find(obj => obj.value === ops.plantTypeId)}
                        options={ops.plantTypes}
                        onChange={(e) => {
                            ops.setPlantTypeId(e.value);
                        }}
                    />
                </div>
                <div style={{ minWidth: "350px" }}>
                    <label>Språk</label>
                    <div className="langs">
                        {ops.ALL_LANGUAGES.map((l: string) => (
                            <div key={l} className="lang">
                                <input id={"lang-" + l} type="checkbox" checked={
                                    ops.languages.indexOf(l) >= 0
                                }
                                    onChange={e => ops.setLanguages(l)}
                                />
                                <label htmlFor={"lang-" + l}>{l}</label>
                            </div>
                        ))}

                    </div>
                </div>
                <div style={{ minWidth: "350px" }}>
                    <label>Fält</label>
                    <Select
                        value={(ops.editFields ?? []).find(obj => obj.value === ops.plantTypeId)}
                        options={ops.editFields}
                        onChange={(e) => {

                        }}
                    />
                </div>

                {Object.keys(ops.changes ?? {}).length > 0 && (
                    <div>
                        <div>{Object.keys(ops.changes ?? {}).length} förändringar:</div>
                        <button onClick={ops.saveChanges}>
                            Spara förändringar
                        </button>
                        {/* {JSON.stringify(ops.changes)} */}
                    </div>
                )}
            </div>
            <hr />

            {/****************************************** TABLE *******************************************/}

            <div>
                <table className="tbl tbl-small translations">
                    <thead id="translations-tbl-header">
                        <tr>
                            <th onClick={() => ops.setSort("name")}>Namn (SE)</th>
                            <th onClick={() => ops.setSort("specifictype")}>Sort (SE)</th>
                            <th>Ändrad</th>

                            <th hidden={hide_no}>
                                <span onClick={() => ops.setSort("name_no")}>NO</span>

                                <button onClick={() => { ops.missing("name_no") }}>
                                    Saknade översättningar
                                </button>
                                <button onClick={() => { ops.resetFilter() }}>
                                    Ta bort filter
                                </button>
                            </th>

                            <th hidden={hide_no}>

                                <span onClick={() => ops.setSort("specifictype_no")}>NO</span>
                                <button onClick={() => { ops.missing("specifictype_no") }}>
                                    Saknade översättningar
                                </button>
                                <button onClick={() => { ops.resetFilter() }}>
                                    Ta bort filter
                                </button>
                            </th>


                            <th hidden={hide_en}>EN-GB</th>
                            <th hidden={hide_en}>EN-GB</th>
                            <th hidden={hide_enus}>EN-US</th>
                        </tr>
                    </thead>
                    <tbody id="translations-tbl-body">
                        {ops.dataFiltered?.filter(m => !!m?.name).map(p => (
                            <tr key={p?.id} data-id={p?.id}>
                                <td>{p?.name}</td>
                                <td>{p?.specifictype}</td>

                                <td>
                                    {!!ops.changes?.[p?.id] && (
                                        <span className="changed">
                                            *
                                        </span>
                                    )}
                                </td>

                                <td hidden={hide_no}>
                                    <TranslationInput value={p?.name_no} onChange={e => {
                                        ops.addUpdate(p, "name_no", e);
                                    }} hasChanged={!!ops.changes?.[p?.id]?.name_no} onUndo={() => ops.addUpdate(p, "name_no", p?.name_no)} />
                                </td>
                                <td hidden={hide_no}>
                                    <TranslationInput value={p?.specifictype_no} onChange={e => {
                                        ops.addUpdate(p, "specifictype_no", e);
                                    }} hasChanged={!!ops.changes?.[p?.id]?.specifictype_no} onUndo={() => ops.addUpdate(p, "specifictype_no", p?.specifictype_no)} />
                                </td>

                                <td hidden={hide_en}>
                                    <TranslationInput value={p?.name_en} onChange={e => {
                                        ops.addUpdate(p, "name_en", e);
                                    }} hasChanged={!!ops.changes?.[p?.id]?.name_en} onUndo={() => ops.addUpdate(p, "name_en", p?.name_en)} />
                                </td>
                                <td hidden={hide_en}>
                                    <TranslationInput value={p?.specifictype_en} onChange={e => {
                                        ops.addUpdate(p, "specifictype_en", e);
                                    }} hasChanged={!!ops.changes?.[p?.id]?.specifictype_en} onUndo={() => ops.addUpdate(p, "specifictype_en", p?.specifictype_en)} />
                                </td>

                                <td hidden={hide_enus}>
                                    <TranslationInput value={p?.name_en_us} onChange={e => {
                                        ops.addUpdate(p, "name_en_us", e);
                                    }} hasChanged={!!ops.changes?.[p?.id]?.name_en_us} onUndo={() => ops.addUpdate(p, "name_en_us", p?.name_en_us)} />
                                </td>
                            </tr>
                        ))}
                    </tbody>
                </table>

            </div>
        </div>
    )
}


const TranslationInput = ({ value, hasChanged, onChange, onUndo }: { value: string, hasChanged: boolean, onChange(e: string): void, onUndo(): void }) => {

    const [_value, _setValue] = useState<string>(value);


    return (
        <div className="inp">
            <input type="text"
                className={"translation-input" + (hasChanged ? " changed-input" : "")}
                value={_value}
                onChange={e => {
                    _setValue(e.target.value)
                    onChange(e.target.value);
                }} />
            {hasChanged && (
                <button className="btn" onClick={() => {
                    _setValue(value)
                    onUndo();
                }}>Ångra</button>
            )}
        </div>)


}